import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import Image from 'next/image'
import Pill from '@/components/base/Pill'
import { HiOutlineLightningBolt } from 'react-icons/hi'
import RPImage from '@/assets/about-us/team/rp.webp'
import AmanImage from '@/assets/about-us/team/aman.webp'
import PulkitImage from '@/assets/about-us/team/pulkit.webp'
import ShreyImage from '@/assets/about-us/team/shreyansh.webp'
import NikhilImage from '@/assets/about-us/team/nikhil.webp'
import ManishImage from '@/assets/about-us/team/manish.webp'
import AbhishekImage from '@/assets/about-us/team/abhishek.webp'
import SameerImage from '@/assets/about-us/team/sameer.webp'
import AshishImage from '@/assets/about-us/team/ashish.webp'
import ZafarImage from '@/assets/about-us/team/zafar.webp'
import BharatImage from '@/assets/about-us/team/bharat.webp'
import AnubhavImage from '@/assets/about-us/team/anubhav.webp'
import HarshImage from '@/assets/about-us/team/harsh.webp'

const OurTeamData = [
	{
		img: RPImage,
		name: 'RP Singh',
		designation: 'Co-Founder',
	},
	{
		img: AmanImage,
		name: 'Aman Tibrewal',
		designation: 'Co-Founder',
	},
	{
		img: PulkitImage,
		name: 'Pulkit Baldev',
		designation: 'Co-Founder',
	},
	{
		img: ManishImage,
		name: 'Manish Bajaj',
		designation: 'Chief of Staff',
	},
	{
		img: ShreyImage,
		name: 'Shreyansh Goyal',
		designation: 'VP, Engineering',
	},
	{
		img: NikhilImage,
		name: 'Nikhil Sirohi',
		designation: 'VP, Product',
	},
	{
		img: HarshImage,
		name: 'Harsh Sharma',
		designation: 'EIR',
	},
	{
		img: AnubhavImage,
		name: 'Anubhav Arora',
		designation: 'Credit Risk Head',
	},
	{
		img: BharatImage,
		name: 'Bharat Bhushan',
		designation: 'SVP, Recycling & Non-Ferrous',
	},
	{
		img: AbhishekImage,
		name: 'Abhishek Sharma',
		designation: 'VP, Ferrous',
	},
	{
		img: SameerImage,
		name: 'Sameer Sarangi',
		designation: 'VP, Sales',
	},
	{
		img: AshishImage,
		name: 'Ashish Chauhan',
		designation: 'VP, Procurement',
	},
	{
		img: ZafarImage,
		name: 'Zafar Mehdi',
		designation: 'EIR',
	},
]

const OurTeam = () => {
	return (
		<div className='our-team-container'>
			<div className='our-team-heading'>
				<Pill text='Our Team' type='quaternary' icon={<HiOutlineLightningBolt />} />
				<h2 className='heading text-center'>Meet the Leadership</h2>
			</div>
			<Row>
				{OurTeamData?.map((item, index) => {
					return (
						<Col xs={6} md={6} lg={3} key={index} className='our-team-card'>
							<Card className='card-rounded p-3'>
								<Image src={item?.img} alt={item?.name} style={{ objectFit: 'cover', borderRadius: '1rem' }} />
								<Card.Body className='pt-3 px-0'>
									<div className='d-flex flex-column'>
										<div>
											<h2 className='heading2'>{item?.name}</h2>
										</div>
										<div>
											<p className='paragraph'>{item?.designation}</p>
										</div>
									</div>
								</Card.Body>
							</Card>
						</Col>
					)
				})}
			</Row>
		</div>
	)
}

export default OurTeam
